import React, { useState, useEffect } from 'react';
import style from './CustomerManagement.module.css';
// import AddCustomerForm from './Search customer/Addcustomer';
import Customerlist from '../Customer/customer list/Customerlist';

const CustomerManagement = () => {

  return (
    <div className={style.container}>
      <div className="row align-items-center">
       
        <div className="col-md-4 text-center">

          {/* <AddCustomerForm /> */}

        </div>
      
      </div>


      <div className="row align-items-center">

        <Customerlist />

      </div>
    </div>
  );
};

export default CustomerManagement;
